export enum TemplateTypes {
  TEMPLATE_1 = 'template_1',
  TEMPLATE_2 = 'template_2',
}

interface TemplateData {
  headerFlexDirection: 'row' | 'row-reverse'
}

const template_1 = {
  headerFlexDirection: 'row',
} as TemplateData

const template_2 = {
  headerFlexDirection: 'row-reverse',
} as TemplateData

export const templateMap: Map<TemplateTypes, TemplateData> = new Map([
  [TemplateTypes.TEMPLATE_1, template_1],
  [TemplateTypes.TEMPLATE_2, template_2],
])
